import React from 'react'

import HeadingWithReloadButton from '@/components/misc/ErrorMessage/components/HeadingWithReloadButton'
import RefreshPagePrompt from '@/components/misc/ErrorMessage/components/RefreshPagePrompt'
import { useCaptureErrorAfterTwoSeconds } from '@/components/misc/ErrorMessage/hooks/useCaptureErrorAfterTwoSeconds'
import CommonDataErrorMessage from '@/components/utils/CommonDataErrorMessage'
import DevOnly from '@/components/utils/DevOnly'
import { COMMON_DATA_ERROR_MESSAGE } from '@/lib/constants'

interface Props {
  error: unknown
}

const UnhandledErrorMessage: React.FC<Props> = ({ error }) => {
  const isCommonDataError =
    error instanceof Error && error?.message.includes(COMMON_DATA_ERROR_MESSAGE)

  useCaptureErrorAfterTwoSeconds(error)

  return (
    <section className="relative">
      <HeadingWithReloadButton>
        Sorry, something went wrong.
      </HeadingWithReloadButton>

      <p className="mb-3">
        We've encountered an issue on our end. Our team has already been
        notified and is working to resolve it as quickly as possible.
      </p>

      <RefreshPagePrompt />

      <DevOnly>
        <div className="flex flex-col">
          {isCommonDataError && <CommonDataErrorMessage />}

          <ul>
            <li>
              <a
                href={`${import.meta.env.VITE_RQ_API_URL}/_profiler/latest`}
                target="_blank"
                rel="noreferrer"
              >
                View last API request
              </a>
            </li>

            <li>
              <a
                href={`${import.meta.env.VITE_RQ_API_URL}/_profiler/search?limit=10`}
                target="_blank"
                rel="noreferrer"
              >
                View last 10 API requests
              </a>
            </li>
          </ul>
        </div>
      </DevOnly>
    </section>
  )
}

export default UnhandledErrorMessage
